import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "14",
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Star 10",
      d: "M7.5 0L9.48378 4.76957L14.6329 5.18237L10.7098 8.54293L11.9084 13.5676L7.5 10.875L3.09161 13.5676L4.29018 8.54293L0.367076 5.18237L5.51622 4.76957L7.5 0Z",
      fill: "#CCCCCC"
    }, null, -1)
  ])))
}
export default { render: render }